($ => {
  var subscribeItems = $('.tribe-events-c-subscribe-dropdown__list li');
  subscribeItems.each((index, li) => {
    if ($(li).find('a').text() == '\n\t\tiCalendar\t') {
      $(li).find('a').html('\n\t\tApple Calendar\t');
      $(li).find('a').addClass('external-link');
    }
  });
})(jQuery);
